import React, { useEffect, useState } from "react";
import "./TopicWisePage.scss";
import images from "../../../../utilities/images/images";
import Subjectchart from "../../components/chart/subjectchart";
import Performance from "../OverallPage/Performance/Performance";
import { useDispatch, useSelector } from "react-redux";
import useAppHooks from "../../../../shared/hooks/useAppHooks";
import { fetchTopicWiseComparisonRequest } from "../../../../redux/exam_analytics/analyticsSlice";
import { ClipLoader } from "react-spinners";

const TopicWisePage = () => {
  const dispatch = useDispatch();
  const { selector } = useAppHooks();

  const { testType, testDetails } = useSelector((s) => s.examSlice); // ⭐ added

  const { topicWiseComparison, loading } = selector((s) => s.analyticsSlice);
  const topicLoading = loading?.topic || false;

  const [selectedTopics, setSelectedTopics] = useState({});

  useEffect(() => {
    // ⭐ ONLY this line changed (uses Redux values)
    if (testDetails?.paper_id && testType?.id) {
      dispatch(
        fetchTopicWiseComparisonRequest({
          paperId: testDetails.paper_id,
          paperType: testType.id,
        })
      );
    }
  }, [dispatch, testDetails, testType]);

  const groupedSubjects = topicWiseComparison?.data?.topic_wise?.reduce(
    (acc, topic) => {
      if (!acc[topic?.subject]) acc[topic?.subject] = [];
      acc[topic?.subject].push(topic);
      return acc;
    },
    {}
  );

  if (topicLoading) {
    return (
      <div className="subjectwise-header subjectwise-loading">
        <ClipLoader color="#C61C26" size={50} />
      </div>
    );
  }

  if (!groupedSubjects)
    return <p style={{ textAlign: "center" }}>No data found</p>;

  return (
    <div className="topicwise-header">
      <h2 className="topicwise-heading">Topic-wise Comparison</h2>

      {Object?.entries(groupedSubjects)?.map(([subject, topics]) => {
        const subjectIcon = topics?.[0]?.subject_icon;
        const subjectColor = topics?.[0]?.sub_color;
        const selectedTopic =
          topics?.find((t) => t?.topic === selectedTopics?.[subject]) ||
          topics?.[0];

        return (
          <div key={subject} className="topicwise-container">
            <div className="topicwise-subject-row">
              <div className="topicwise-subject-left">
                <img
                  src={subjectIcon || images.physics_icon}
                  alt="subject icon"
                  className="topicwise-subject-icon"
                />
                <span
                  className="topicwise-subject-name"
                  style={{ color: subjectColor }}
                >
                  {subject}
                </span>
              </div>
              <div className="topicwise-topic-count">
                {topics.length} Topics
              </div>
            </div>

            <div className="topicwise-dropdown-section">
              <label className="topicwise-dropdown-label">Select Topic:</label>
              <select
                className="topicwise-dropdown"
                value={selectedTopics?.[subject] || topics?.[0]?.topic}
                onChange={(e) =>
                  setSelectedTopics({
                    ...selectedTopics,
                    [subject]: e.target.value,
                  })
                }
              >
                {topics?.map((t) => (
                  <option key={t?.topic} value={t?.topic}>
                    {t?.topic}
                  </option>
                ))}
              </select>
            </div>

            <div className="topicwise-overview">
              <div className="topicwise-overview-title">
                {selectedTopic?.topic} - Overview
              </div>
            </div>

            <div className="topicwise-overview-container">
              <div className="topicwise-overview-subjectchart">
                <Subjectchart topic={selectedTopic} />
              </div>
              <div className="topicwise-overview-performance">
                <Performance
                  performanceData={selectedTopic?.performance_comparison}
                  totalPossible={selectedTopic?.total_possible}
                />
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default TopicWisePage;
